module.exports = "./img/348884ceaf3584fb2a26bfd4f3336315.png";